import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoutes = () => {
  const accessToken = sessionStorage.getItem("accessToken") || false;

  return !accessToken ? <Outlet /> : <Navigate to="/" />;
};

export default PublicRoutes;
